import styled from 'styled-components';
import { TableCellStyled } from '../styled';

const TableCellId = styled(TableCellStyled)`
  width: 120px;
`;

export default TableCellId;
